"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TrackerMessage_1 = __importDefault(require("../TrackerMessage"));
const StatusAckMessage_1 = __importDefault(require("./StatusAckMessage"));
const Serializer_1 = require("../../../Serializer");
const StreamID_1 = require("../../../utils/StreamID");
const VERSION = 2;
/* eslint-disable class-methods-use-this */
class StatusAckMessageSerializerV2 extends Serializer_1.Serializer {
    toArray(statusAckMessage) {
        return [
            VERSION,
            TrackerMessage_1.default.TYPES.StatusAckMessage,
            statusAckMessage.requestId,
            statusAckMessage.streamId,
            statusAckMessage.streamPartition
        ];
    }
    fromArray(arr) {
        const [version, _type, requestId, streamId, streamPartition] = arr;
        return new StatusAckMessage_1.default({
            version,
            requestId,
            streamId: (0, StreamID_1.toStreamID)(streamId),
            streamPartition
        });
    }
}
exports.default = StatusAckMessageSerializerV2;
TrackerMessage_1.default.registerSerializer(VERSION, TrackerMessage_1.default.TYPES.StatusAckMessage, new StatusAckMessageSerializerV2());
//# sourceMappingURL=StatusAckMessageSerializerV2.js.map